import React from "react";
import { FamilySummary, PlaydateInvite, SeenStatus, User, UserSummary } from "../../gql/types"; // Adjust import path if needed
import { TagVariant } from "./InfoTag";
import PlaydateInviteBaseUnit from "./PlaydateInviteBaseUnit";
import { outboundTopLeftLabelComputer } from "./outboundTopLeftLabelComputer";
import { inviteStatusTagComputer } from "./inviteStatusTagComputer";
import { voteStatusTagComputer } from "./voteStatusTagComputer";
import { outboundTagsResolver } from "./tags/outboundTagResolver";

interface PlaydateInviteOutboundUnitProps {
    user?: User;
    invite: PlaydateInvite;
    onResponse: () => void;
}

const PlaydateInviteOutboundUnit: React.FC<PlaydateInviteOutboundUnitProps> = ({ user, invite, onResponse }) => {
    // 1) Check if this invite is "new" based on guestUpdate.seenState
    const isNew = invite.organizerUpdate?.seenState === SeenStatus.New;
    const topLeftTags: Array<{ label: string; variant: TagVariant }> = outboundTagsResolver(invite);

    // Use the guest count - 1 for represented user
    const otherGuestCount = invite.guests && invite.guests.length > 1
        ? invite.guests.length - 1
        : 0;

    let representedPerson: UserSummary | FamilySummary | undefined;
    if (invite.organizerUpdate && invite.organizerUpdate.lastResponder) {
        if (invite.organizerUpdate.lastResponder.responder) {
            representedPerson = invite.organizerUpdate.lastResponder.responder;
        } else if (invite.organizerUpdate.lastResponder.externalGuest) {
            representedPerson = {
                firstName: invite.organizerUpdate.lastResponder.externalGuest.name,
            } as UserSummary;
        }
    }

    if (!representedPerson) {
        if (invite.guests && invite.guests.length > 0) {
            representedPerson = invite.guests[0];
        } else {
            if (invite.externalGuests && invite.externalGuests.length > 0) {
                const externalGuest = invite.externalGuests[0];
                representedPerson = {
                    firstName: externalGuest.name,
                } as UserSummary;
            } else {
                // assume the user sent it out an external user family.
                representedPerson = {
                    firstName: "External User",
                } as UserSummary;
            }
        }
    }

    return (
        <PlaydateInviteBaseUnit
            user={user}
            isNew={isNew}
            isInbound={false}
            infoTags={topLeftTags}
            otherGuestsCount={otherGuestCount}
            representedPerson={representedPerson}
            invite={invite}
            onResponse={onResponse}
        />
    );
};

export default PlaydateInviteOutboundUnit;
